"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountMasks = exports.ssnMasks = exports.postalCodeMasks = exports.phoneMasks = void 0;
var phoneMasks = {
  nb: [/[1-9]/, /\d/, /\d/, " ", /\d/, /\d/, " ", /\d/, /\d/, /\d/]
};
exports.phoneMasks = phoneMasks;
var postalCodeMasks = {
  nb: [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]
};
exports.postalCodeMasks = postalCodeMasks;
var ssnMasks = {
  nb: [/[0-9]/, /[0-9]/, /[0-1]/, /[0-9]/, /[0-9]/, /[0-9]/, " ", /\d/, /\d/, /\d/, /\d/, /\d/]
};
exports.ssnMasks = ssnMasks;
var accountMasks = {
  nb: {
    blocks: [4, 2, 5],
    numericOnly: true,
    delimiter: "·"
  }
};
exports.accountMasks = accountMasks;